<template>
  <div class="cascade-region">
    <template v-if="cascadeOptions.length">
      <el-cascader :disabled="view" ref="cascaderRef" :props="props" v-model="value" @change="onChangeValue"></el-cascader>
    </template>
  </div>
</template>

<script>
export default {
  changeExpr: 'issue.answerValue',
  name: 'CascadeRegion',
  data() {
    const vm = this
    return {
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          if (level === 0) {
            resolve(vm.cascadeOptions)
          } else {
            if (node.data.next === 0) {
              resolve([])
            } else {
              vm.issue.getCascade(node.data.regionCode).then(resolve)
            }
          }
        },
        label: 'regionName',
        value: 'regionCode'
      },
      cascadeOptions: [],
      value: []
    }
  },
  created() {
    this.issue.getCascade().then(res => {
      this.cascadeOptions = res
    })
  },
  methods: {
    onChangeValue() {
      let nodes = this.$refs.cascaderRef.getCheckedNodes()
      let results = []
      for (let i = 0, len = nodes.length; i < len; i++) {
        let node = nodes[i]
        node.path.forEach((code, index) => {
          results.push({
            optionId: code,
            value: node.pathLabels[index],
            rowId: '',
            colId: ''
          })
        })
      }
      this.issue.answerValue = results
    }
  },
  mounted() {
    if (this.issue.answerValue.length) {
      this.value = this.issue.answerValue.map(i => i.optionId)
      const uw = this.$watch('cascadeOptions', () => {
        uw && uw()
        this.$nextTick(() => {
          this.$refs.cascaderRef.inputValue = this.issue.answerValue.map(i => i.value).join('/')
        })
      })
    }
  }
}
</script>
